import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.whats-new';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="product-image">
              <img src="${item.image}" alt="${item.title}">
            </div>
            <div class="content-wrapper">
              <h3 class="title">${item.title || ''}</h3>
              <p class="details">${item.details || ''}</p>
              <div class="buttons-wrapper">
                ${item.link ? `<a href="${item.link}" class="btn-custom primary">${item.button}</a>` : ''}
                ${item.download ? `<a href="${item.download}" target="_blank" class="btn-custom secondary" rel="noreferrer noopener" ><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M15.3336 15.9165V16.5835H4.66663V15.9165L15.3336 15.9165ZM11.9996 3.4165V8.4165H14.6266L9.99963 13.0425L5.37366 8.4165H7.99963L7.99963 3.4165L11.9996 3.4165Z" fill="white" stroke="white"/>
                </svg></a>` : ''}
              </div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.whats-new .splide').forEach((item) => {
    const moduleRoot = item.closest('.whats-new');
    if (!moduleRoot) return;

    const leftSection = moduleRoot.querySelector('.left-section') || moduleRoot;
    const placeholderWrapper = leftSection.querySelector('.pagination-wrapper');
    let paginationAnchor = leftSection.querySelector('[data-splide-pagination-anchor]');

    if (!paginationAnchor) {
      paginationAnchor = document.createElement('span');
      paginationAnchor.setAttribute('data-splide-pagination-anchor', 'true');
      paginationAnchor.style.display = 'none';
      if (placeholderWrapper?.parentNode) placeholderWrapper.parentNode.insertBefore(paginationAnchor, placeholderWrapper);
      else leftSection.appendChild(paginationAnchor);
    }

    const slider = new Splide(item, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: 20,
      pagination: true,
      arrows: false,
      autoplay: false,
      breakpoints: {
        991: {
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    });

    const movePaginationIntoWrapper = (listEl) => {
      // Prefer the pagination that Splide has (re)attached inside the slider.
      const list = listEl
        || item.querySelector('.splide__pagination')
        || moduleRoot.querySelector('.splide__pagination');

      if (!list) return;

      // Keep Splide pagination in the left section even after breakpoint refresh.
      list.classList.add('pagination-wrapper');

      // First move: replace the placeholder. Later: insert after the anchor.
      if (placeholderWrapper && placeholderWrapper.isConnected) placeholderWrapper.replaceWith(list);
      else if (paginationAnchor?.isConnected && paginationAnchor.nextSibling !== list) paginationAnchor.after(list);

      // If Splide recreated/duplicated pagination, remove extras.
      moduleRoot.querySelectorAll('.splide__pagination').forEach((el) => {
        if (el !== list && el.parentNode) el.parentNode.removeChild(el);
      });
    };

    const scheduleMove = (listEl) => {
      // Run after Splide finishes refresh/resize DOM work.
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => movePaginationIntoWrapper(listEl));
      });
    };

    slider.on('mounted', () => scheduleMove());
    slider.on('updated', () => scheduleMove());
    slider.on('refresh', () => scheduleMove());
    slider.on('resized', () => scheduleMove());
    slider.on('pagination:mounted', (data) => scheduleMove(data?.list));
    slider.on('pagination:updated', (data) => scheduleMove(data?.list));

    const observer = new MutationObserver(() => scheduleMove());
    observer.observe(item, { childList: true, subtree: true });
    slider.on('destroy', () => observer.disconnect());

    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
